export const toKodArray = (kod: string | null): string[] => {
  if (kod && kod?.trim()?.length > 0) {
    return [kod];
  }
  return [];
};
